export default __webpack_public_path__ + "static/media/products.81dfe561.jpeg";